import {
    BackButton,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDate,
    FormDropDown,
    FormInput,
    FormRadio,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileResidentClaim = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Residents_Claim.claim' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Residents_Claim.claimDetails' />}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
                allowEdit={props.allowEdit}
            >
                <FormDate
                    label={<FormattedMessage id='Profile_Residents_Claim.dateOfClaim' />}
                    value={props.claim?.eventDate}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}eventDate`, value })}
                    culture={props.context.session.culture}
                    mode='past'
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Residents_Claim.claimReason' />}
                    value={props.claim?.reason}
                    references={props.reference.references?.DwellingClaims}
                    referencesEvent={() => props.reference.doGetReferences('DwellingClaims')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}reason`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Residents_Claim.lossAmount' />}
                    value={props.claim?.amount?.value}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}amount.value`, value });
                        props.doReducePolicyElement({ code: `${props.dotProp}amount.currency`, value: 'cad' });
                    }}
                    allowEdit
                />
                <FormRadio
                    label={<FormattedMessage id='Profile_Residents_Claim.currentRisk' />}
                    value={props.claim && { code: convertFromBoolean(props.claim.currentRisk) }}
                    references={props.reference.references?.YesNo}
                    referencesEvent={() => props.reference.doGetReferences('YesNo')}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({
                            code: `${props.dotProp}currentRisk`,
                            value: convertToBoolean(value.code),
                        })
                    }
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileResidentClaim;
